import React from 'react';
import { Formik, Form } from 'formik';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { LockerCreateReservationContainer } from '../components/LockerCreateReservation/LockerCreateReservationContainer';
import { LockerCreateReservationHeader } from '../components/LockerCreateReservation/LockerCreateReservationHeader';
import { LockerCreateReservation } from '../components/LockerCreateReservation/LockerCreateReservation';
import { LockerCreateReservationActions } from '../components/LockerCreateReservation/LockerCreateReservationActions';
import { LockerCreateReservationLoading } from '../components/LockerCreateReservation/LockerCreateReservationLoading';
import { initialValues } from '../constants/lockerReservationConstants';
import { lockerReservationValidationSchema } from '../validations/lockerReservationValidationSchema';
import { useLockerReservationForm } from '../hooks/useLockerReservationForm';
import { useQuery } from '@tanstack/react-query';
import { lockerReservationService } from '../../../shared/services/lockers/lockerReservationService';
import { LockerCreateReservationErrorHandler } from '../components/LockerCreateReservation/LockerCreateReservationErrorHandler';

export default function LockerCreateReservationPage() {
  const { id, lockerId } = useParams();
  const mode = id ? 'edit' : 'create';
  const { handleSubmit, handleUpdate, isSubmitting, error, setError } = useLockerReservationForm();

  // Buscar dados da reserva no modo de edição
  const { data: reservationData, isLoading: isLoadingReservation } = useQuery({
    queryKey: ['locker-reservation', id],
    queryFn: () => lockerReservationService.getById(id!),
    enabled: !!id,
  });

  const handleFormSubmit = async (values: any) => {
    if (mode === 'create') {
      // Adicionar o lockerId aos valores do formulário
      const valuesWithLockerId = {
        ...values,
        lockerId: lockerId
      };
      await handleSubmit(valuesWithLockerId);
    } else {
      await handleUpdate(id!, values);
    }
  };

  const handleCloseError = () => {
    setError(null);
  };

  if (isLoadingReservation) {
    return <LockerCreateReservationLoading />;
  }

  const formInitialValues = mode === 'create' ? initialValues : {
    equipmentId: reservationData?.equipmentId || '',
    userId: reservationData?.userId || '',
    durationHours: reservationData?.durationHours || 1,
    startDate: reservationData?.startDate || new Date().toISOString().split('T')[0],
    startTime: reservationData?.startTime || '09:00',
  };

  return (
    <>
      <LockerCreateReservationErrorHandler error={error} onClose={handleCloseError} />
      <LockerCreateReservationContainer>
        <LockerCreateReservationHeader mode={mode} />
        <Formik
          initialValues={formInitialValues}
          validationSchema={lockerReservationValidationSchema}
          onSubmit={handleFormSubmit}
          enableReinitialize
        >
          {({ values, errors, touched, isSubmitting: formikSubmitting }) => (
            <Form>
              <Grid container spacing={3}>
                <LockerCreateReservation
                  mode={mode}
                  isSubmitting={isSubmitting || formikSubmitting}
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <LockerCreateReservationActions
                isSubmitting={isSubmitting || formikSubmitting}
                mode={mode}
              />
            </Form>
          )}
        </Formik>
      </LockerCreateReservationContainer>
    </>
  );
}
